export default __webpack_public_path__ + "90d112577c941a8701fd24fad7ad9a3d.png";